import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=0131be6e&scoped=true&"
import script from "./WidgetCard.vue?vue&type=script&lang=js&"
export * from "./WidgetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131be6e",
  null
  
)

export default component.exports